import React from "react";
import { Story3Style } from "./css/Story3Style";
import OutroLogo from "../../components/editor/Templates/OutroLogo";
import OutroText from "../../components/editor/Templates/OutroText";

const story_3 = (props) => {
  return (
    <Story3Style>
      <div className="poster flex-column">
        <div className="poster-content">
          <div className="logo-container flex-column">
            <OutroLogo logo={props.file} />
          </div>
          <div className="text-wrapper flex-column">
            <OutroText
              id={props.id}
              text={props.text}
              textStyle={props.textStyle}
              editStatus={props.editStatus}
              onInputSlideText={props.onInputSlideText}
            />
          </div>
        </div>
      </div>
    </Story3Style>
  );
};

export default story_3;
